import React, { useCallback } from 'react';
import { ACCORDION_VARIANT, colors } from '@manulife/mux';
import { v4 as uuidv4 } from 'uuid';
import { FasatIcon, FasatButtonSelector, FasatActionBtn, FasatButton, FasatColumnOrder, FasatDropdown, FasatExpandablePanel, FasatLabel } from '../index';
import FilterCriteria from './filterCriteria/filterCriteria';
import SortOrder from './sortOrder/sortOrder';
import GroupBy from './groupBy/groupBy';
import Distinct from './distinct/distinct';
import './index.scss';
import { generateOptions, ReturnSaveButton, grpByIsActive, operatorBtwnValidate } from './filterUtil';
import { staticCommonLabelKeys as cmnLblKey, staticCommonLabelKeys } from '../../moduleConstants';

const filterExpandablePanelID = 'filterExpandablePanel';
const filterCriteriaPanelID = 'filterCriteriaPanelID';
const sortOrderPanelID = 'sortOrderPanelID';
const groupByPanelID = 'groupByPanelID';
const columnOrderPanelID = 'columnOrderPanelID';
const panelHeaderSectionClass = 'panelHeaderSection';
const panelHeaderTextClass = 'panelHeaderText';
const sysDefaultFilterHeaderClass = 'sysDefaultFilterHeader';
const panelActionAreaClass = 'panelActionArea';
const loadFilterClass = 'loadFilter';
const loadDropdownID = 'load';
const loadLabelFor = 'load';
const filterSettingsPanelLevel2Class = 'filterSettingsPanel_level2';
const panelFooterActionContainerClass = 'panelFooterActionContainer';
const filterSettingsPanelTextClass = 'filterSettingsPanelText';
const filterSubAccordionPanelTextClass = 'filterSubAccordionPanelText';
export const setHeaderClass = (currentFilterObject) => (currentFilterObject?.isSystemFilter ? `${sysDefaultFilterHeaderClass} ${panelHeaderTextClass}` : panelHeaderTextClass);
export const hasFilterName = (currentFilterObject) => (currentFilterObject?.name);
export const hasFilterDescription = ({ currentFilterObject }) => (currentFilterObject?.description);
/**
       * Functionality on click of Search button
       */
const optionArray = ['OPT_BETWEEN', 'OPT_NOT_BETWEEN'];
export const searchFunc = ({ columnOrder, custFilCreteria, displayWarningMessage,
  setValidateFilterCriteria, triggerSearch, setDisplayWarningMessage, setDisplayBetWarningMsg,
  displayBetWarningMsg }) => {
  if (columnOrder.length > 0) {
    if (custFilCreteria.length > 0) {
      const filterValidate = operatorBtwnValidate(custFilCreteria);
      if (filterValidate.find((idx) => optionArray.includes(idx.operator)) !== undefined) {
        setDisplayBetWarningMsg(!displayBetWarningMsg);
      } else {
        triggerSearch();
        setValidateFilterCriteria(0);
      }
    } else {
      triggerSearch();
      setValidateFilterCriteria(0);
    }
  } else {
    setDisplayWarningMessage(!displayWarningMessage);
  }
};

const setSelColumn = (columnOrders) => columnOrders || [];
const setSortOpts = (sortOptions) => sortOptions || null;
/**
     * This is to configure the Pre selected Filter Criteria
     */
export const selectedFilFun = ({ filterData, setSelectedColumn, setSelectedGroupByOption,
  setSelectedSortOptions, setSelectedParametOptions, setGroupByActive, setIsDistinct }) => {
  if (filterData.detail) {
    setIsDistinct(filterData.detail.isDistinct);
    setSelectedColumn(setSelColumn(filterData.detail.columnOrders));
    if (filterData.detail.groupByParameters) {
      setSelectedGroupByOption(filterData.detail.groupByParameters);
      if (filterData.detail.groupByParameters.length > 0) {
        setGroupByActive(true);
      }
    }
    setSelectedSortOptions(setSortOpts(filterData.detail.sortOptions));

    if (filterData.detail.parameters) {
      setSelectedParametOptions(filterData.detail.parameters);
    } else {
      setSelectedParametOptions([]);
    }
  }
};

export const resetFilter = (toggleValue, resetPreSelectedFilterConfig) => {
  if (!toggleValue && resetPreSelectedFilterConfig) {
    resetPreSelectedFilterConfig();
  }
};

function FilterUtilityHeader({ headFilObj, createNewFilter, userDefaultFilter, selectedFilterType, loadDropdown }) {
  const { t, filterTag, currentFilterObject, getFilterTitleDesc, sharedFilterCount, createNewFilterFlag } = headFilObj;
  return (
    <>
      <div className={panelHeaderSectionClass}>
        <h2 className={setHeaderClass(currentFilterObject)}>
          {hasFilterName(currentFilterObject) ? getFilterTitleDesc('title')
            : t(cmnLblKey.FILTER_LABEL_NEW)}
        </h2>
        {!currentFilterObject?.isSystemDefaultFilter && filterTag()}
        <div className={panelActionAreaClass}>
          <div>
            {hasFilterName(currentFilterObject) && !createNewFilterFlag && (
              <FasatActionBtn
                icon={(<FasatIcon aria-hidden="true" color="none" fill={colors.m_green} manulifeName="plus1" width="20px" height="20px" />)}
                hoverIcon={(
                  <FasatIcon aria-hidden="true" color="none" fill={colors.dark_2_green} manulifeName="plus1" width="20px" height="20px" />)}
                onClick={createNewFilter}
                data-testid="filter-create-new-button"
              >
                {t(cmnLblKey.FILTER_LABEL_CREATE_NEW)}
              </FasatActionBtn>
            )}
          </div>
          <div className={loadFilterClass}>
            <FasatLabel isContent htmlFor={loadLabelFor} data-testid="filter-management-label">
              {t(cmnLblKey.FILTER_LABEL_MANAGEMENT)}
            </FasatLabel>
            <FasatDropdown
              dropdownItems={generateOptions({ t, userDefaultFilter, sharedFilterCount })}
              id={loadDropdownID}
              placeholder={t(staticCommonLabelKeys.COMMON_PLACEHOLDER_SELECT)}
              value={selectedFilterType}
              onHandleChange={useCallback((loadDropdownValue) => loadDropdown(loadDropdownValue), [loadDropdown])}
              label={t(cmnLblKey.FILTER_LABEL_MANAGEMENT)}
              data-testid="filter-management-dropdown"
            />
          </div>
        </div>
      </div>
      <p className={filterSettingsPanelTextClass} data-testid="filter-setting-panel-label">
        {hasFilterDescription({ currentFilterObject }) && getFilterTitleDesc('desc')}
        {!hasFilterDescription({ currentFilterObject })
                && t(cmnLblKey.FILTER_LABEL_HELP)}
      </p>
    </>
  );
}
const filterColumnOrder = ({ t, availableColumns, columnOrderChange, selectedColumn, deselectColumnOrder }) => (
  <FasatExpandablePanel
    id={columnOrderPanelID}
    variant={ACCORDION_VARIANT.SECONDARY}
    title={t(cmnLblKey.FILTER_LABEL_VISIBILITY)}
    data-testid="filter-column-order-panel"
  >
    <p className={filterSubAccordionPanelTextClass} data-testid="filter-column-order-label">{t(cmnLblKey.FILTER_LABEL_VISIBILITY_HELP)}</p>
    <FasatColumnOrder
      options={availableColumns}
      columnOrderChange={columnOrderChange}
      selectedOptions={selectedColumn}
      deselectColumnOrder={deselectColumnOrder}
    />
  </FasatExpandablePanel>
);
const srtOrd = ({ t, availableColumns, sortedColumn, removeSortedColumn, customColumnGroupBy, groupByActive,
  customColumnSorting, showDuplicateMessage }) => (
    <FasatExpandablePanel
      id={sortOrderPanelID}
      variant={ACCORDION_VARIANT.SECONDARY}
      title={t(cmnLblKey.FILTER_LABEL_SORT_ORDER)}
      data-testid="filter-sort-order-panel"
    >
      <p className={filterSubAccordionPanelTextClass} data-testid="filter-sort-order-label">{t(cmnLblKey.FILTER_LABEL_SORT_ORDER_HELP)}</p>
      <SortOrder
        columns={availableColumns}
        sortedColumn={sortedColumn}
        removeSortedColumn={removeSortedColumn}
        customColumnOrder={customColumnSorting}
        showDuplicateMessage={showDuplicateMessage}
        customColumnGroupBy={customColumnGroupBy}
        groupByActive={groupByActive}
      />
    </FasatExpandablePanel>
);
function GroupByYesNo({ t, groupByActive, setGroupByActive, setCustomColumnGroupBy,
  setCustomColumnSorting, setIsColumnOrderChange }) {
  return (
    <FasatButtonSelector
      values={[{ label: t(cmnLblKey.COMMON_BUTTON_YES), value: true },
        { label: t(cmnLblKey.COMMON_BUTTON_NO), value: false }]}
      customStyle={{ rootStyle: { width: '240px', paddingTop: '0px', paddingBottom: '12px' } }}
      onHandleChange={useCallback((val) => {
        grpByIsActive(
          val,
          setGroupByActive,
          setCustomColumnGroupBy,
          setCustomColumnSorting,
          setIsColumnOrderChange,
        );
      }, [grpByIsActive])}
      id="grpby_option"
      name="groupby-option"
      value={groupByActive}
      ariaLabel={t(cmnLblKey.FILTER_LABEL_GROUP_BY)}
      data-testid="group-by-button-selector"
    />
  );
}
const grpBy = ({ t, operatorList, availableColumns, lookupData, setCustomColumnSorting,
  groupByColumn, removeGroupByColumn, setIsColumnOrderChange,
  customColumnGroupBy, setCustomColumnGroupBy, showDuplicateMessage, groupByActive, setGroupByActive }) => (
    <FasatExpandablePanel
      id={`${groupByPanelID}-${uuidv4()}`}
      variant={ACCORDION_VARIANT.SECONDARY}
      title={t(cmnLblKey.FILTER_LABEL_GROUP_BY)}
      data-testid="filter-group-by-panel"
    >
      <p className={filterSubAccordionPanelTextClass} data-testid="filter-group-by-label">{t(cmnLblKey.FILTER_LABEL_GROUP_BY_HELP)}</p>
      <GroupByYesNo
        t={t}
        groupByActive={groupByActive}
        setGroupByActive={setGroupByActive}
        setCustomColumnGroupBy={setCustomColumnGroupBy}
        setCustomColumnSorting={setCustomColumnSorting}
        setIsColumnOrderChange={setIsColumnOrderChange}
      />
      {operatorList && (
        <GroupBy
          columns={availableColumns}
          groupByColumn={groupByColumn}
          groupByActive={groupByActive}
          removeGroupByColumn={removeGroupByColumn}
          customColumnGroupBy={customColumnGroupBy}
          showDuplicateMessage={showDuplicateMessage}
          operatorList={operatorList}
          lookupData={lookupData}
        />
      )}
    </FasatExpandablePanel>
);
const distinctPanel = ({ t, groupByActive, isDistinct, setIsDistinct, setCustomColumnSorting }) => (
  <FasatExpandablePanel
    id={`${groupByPanelID}-${uuidv4()}`}
    variant={ACCORDION_VARIANT.SECONDARY}
    title={t(cmnLblKey.FILTER_LABEL_DISTINCT)}
    data-testid="filter-distinct-panel"
  >
    <p className={filterSubAccordionPanelTextClass} data-testid="filter-distinct-label">{t(cmnLblKey.FILTER_LABEL_DISTINCT_HELP)}</p>
    <Distinct
      isGroupByActive={groupByActive}
      isDistinct={isDistinct}
      setIsDistinct={setIsDistinct}
      setCustomColumnSorting={setCustomColumnSorting}
      data-testid="filter-distinct-component"
    />
  </FasatExpandablePanel>
);
const filCriteria = ({ t, operatorList, availableColumns, lookupData, setfiterCriteria, freezeColumn,
  removeFilCriElmt, custFilCreteria, showDuplicateMessage, validateFilterCriteria }) => (
    <FasatExpandablePanel
      id={filterCriteriaPanelID}
      variant={ACCORDION_VARIANT.SECONDARY}
      title={t(cmnLblKey.FILTER_LABEL_CRITERIA)}
      expandedByDefault
      data-testid="filter-criteria-panel"
    >
      <p className={filterSubAccordionPanelTextClass} data-testid="filter-criteria-label">{t(cmnLblKey.FILTER_LABEL_CRITERIA_HELP)}</p>
      {operatorList && (
        <FilterCriteria
          columns={availableColumns}
          operatorList={operatorList}
          lookupData={lookupData}
          onValueChange={setfiterCriteria}
          removeFilterCriteriaElement={removeFilCriElmt}
          customFilterCreteriaElement={custFilCreteria}
          showDuplicateMessage={showDuplicateMessage}
          freezeColumn={freezeColumn}
          validateFilterCriteria={validateFilterCriteria}
        />
      )}
    </FasatExpandablePanel>
);
function FilterPanel({ t, resetPreSelectedFilterConfig, headFilObj,
  createNewFilter, userDefaultFilter, search, selectedFilterType, loadDropdown, lookupData,
  availableColumns, filCriteriaObj, freezeColumn, custFilCreteria, validateFilterCriteria,
  sortedColumn, groupByColumn, removeSortedColumn, removeGroupByColumn, customColumnSorting,
  customColumnGroupBy, setCustomColumnGroupBy, columnOrderChange, currentFilterObject,
  showDuplicateMessage, selectedColumn, deselectColumnOrder, loggedInUser, openSaveFilterModal,
  groupByActive, setGroupByActive, setCustomColumnSorting, setIsColumnOrderChange, entityFilterConfig,
  isDistinct, setIsDistinct, filterPanelExpanded, setFilterPanelExpanded }) {
  // Only update state if value is different - prevents MUX onToggle callback from resetting programmatic changes
  const handleToggle = useCallback((val) => {
    if (val !== filterPanelExpanded) {
      setFilterPanelExpanded(val);
      resetFilter(val, resetPreSelectedFilterConfig);
    }
  }, [filterPanelExpanded, setFilterPanelExpanded, resetPreSelectedFilterConfig]);
  return (
    <FasatExpandablePanel
      id={filterExpandablePanelID}
      title={t(cmnLblKey.FILTER_LABEL_SETTING)}
      expanded={filterPanelExpanded}
      onToggle={handleToggle}
      data-testid="filter-settings-panel"
    >
      <FilterUtilityHeader
        headFilObj={headFilObj}
        createNewFilter={createNewFilter}
        userDefaultFilter={userDefaultFilter}
        selectedFilterType={selectedFilterType}
        loadDropdown={loadDropdown}
      />
      <div className={filterSettingsPanelLevel2Class}>
        {filCriteria({ ...filCriteriaObj, t, lookupData, freezeColumn, custFilCreteria, validateFilterCriteria })}
        {entityFilterConfig.IS_GROUPBY && (grpBy({
          ...filCriteriaObj,
          t,
          availableColumns,
          groupByColumn,
          removeGroupByColumn,
          customColumnGroupBy,
          setCustomColumnGroupBy,
          showDuplicateMessage,
          groupByActive,
          setGroupByActive,
          setCustomColumnSorting,
          setIsColumnOrderChange,
        }))}
        {entityFilterConfig.IS_DISTINCT
                && distinctPanel({ t, groupByActive, isDistinct, setIsDistinct, setCustomColumnSorting })}
        {srtOrd({
          t,
          availableColumns,
          sortedColumn,
          groupByActive,
          removeSortedColumn,
          customColumnSorting,
          showDuplicateMessage,
          customColumnGroupBy,
        })}
        {!groupByActive
                && filterColumnOrder({ t, availableColumns, columnOrderChange, selectedColumn, deselectColumnOrder })}
      </div>
      <div className={panelFooterActionContainerClass}>
        {ReturnSaveButton({ t, currentFilterObject, loggedInUser, openSaveFilterModal })}
        <FasatButton id="searchButton" data-testid="filter-search-button" onClick={search}>{t(cmnLblKey.COMMON_BUTTON_SEARCH)}</FasatButton>
      </div>
    </FasatExpandablePanel>
  );
}

export default FilterPanel;
